export class DocumentsStats {
  filesAmount: number;
  size: number;

  constructor(filesAmount: number, size: number) {
    this.filesAmount = filesAmount;
    this.size = size;
  }
}

export class Document {
  name: string;
  size: number;
  extension: string;
  docId: string;
  uploadedAt: string;
  type: string;
  status: string;
  thumbnail?: string;
  progress?: number;
  selection?: Selection;
  progressLabel?: string;

  constructor(name: string, size: number, extension: string, docId: string, uploadedAt: string, type: string, status: string, thumbnail?: string, progress?: number, selection: Selection = {isSelected: false, selectionMode: false}, progressLabel?: string) {
    this.name = name;
    this.size = size;
    this.extension = extension;
    this.docId = docId;
    this.uploadedAt = uploadedAt;
    this.type = type;
    this.status = status;
    this.thumbnail = thumbnail;
    this.progress = progress;
    this.selection = selection;
    this.progressLabel = progressLabel;
  }
}

export class BrowseDocuments {
  documents: Document[];
  stats: DocumentsStats;

  constructor(documents: Document[], stats: DocumentsStats) {
    this.documents = documents;
    this.stats = stats;
  }
}

export class UploadedDocument {
  document: Document;
  progress: number;
  status: string;

  constructor(document: Document, progress: number, status: string) {
    this.document = document;
    this.progress = progress;
    this.status = status;
  }
}

export class ScrollPosition {
  page: number;
  fromButton: boolean;

  constructor(page: number, fromButton: boolean) {
    this.page = page;
    this.fromButton = fromButton;
  }
}

export class Selection {
  selectionMode: boolean;
  isSelected: boolean;

  constructor(selectionMode: boolean = false, isSelected: boolean = false) {
    this.selectionMode = selectionMode;
    this.isSelected = isSelected;
  }
}
